// Referentiecode (ORG-, TRN-, EDN-, PER-) als klein label. Klik kopieert hem,
// zodat hij zonder tikfouten in een mail of factuur komt.
import { esc } from '../lib/format.js';
import { t } from '../lib/i18n.js';
import { toast } from './toast.js';

export const refLabel = ref => ref
  ? `<button type="button" class="ref-code" data-ref="${esc(ref)}" title="${esc(t('ref.kopieer'))}">${esc(ref)}</button>` : '';

// Eén keer op document-niveau: werkt voor elk label, ook in vensters.
let gekoppeld = false;
export function koppelRef() {
  if (gekoppeld) return;
  gekoppeld = true;
  document.addEventListener('click', async e => {
    const k = e.target.closest('.ref-code[data-ref]');
    if (!k) return;
    e.stopPropagation();
    try { await navigator.clipboard.writeText(k.dataset.ref); toast(t('ref.gekopieerd', { code: k.dataset.ref }), 'success'); }
    catch { /* geen klembord: de code staat er leesbaar */ }
  }, true);
}
